import TabsComp from "../../components/TabsComp";
import styles from "./Section4.module.css";

const phases = [
  {
    title: "Client Briefing",
    text: "We begin by understanding your products, services, goals, and target audience to shape the right outreach strategy.",
  },
  {
    title: "Script Development",
    text: "We create tailored call scripts that clearly present your value proposition while keeping conversations natural and engaging.",
  },
  {
    title: "Campaign Execution",
    text: "Our team launches the telemarketing campaign, connects with your target audience, and captures responses and lead data.",
  },
  {
    title: "Reporting & Analysis",
    text: "We provide performance reports with call outcomes, insights, and recommendations to improve campaign effectiveness.",
  },
  {
    title: "Follow-up & Retargeting",
    text: "We continue engagement through follow-up calls and retargeting efforts to help increase conversions and close more opportunities.",
  },
];

export default function Section4() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.mediaPanel}>
          <img
            src="/img/marketing/telemarketing.webp"
            alt="telemarketing showcase"
            className={styles.showcaseImage}
          />
        </div>
        <div className={styles.contentPanel}>
          <span className={styles.kicker}>Telemarketing</span>
          <h2>Reliable Telemarketing Support</h2>

          <div className={styles.tabsWrap}>
            <TabsComp
              items={phases}
              initialActiveIndex={0}
              showNumbers={true}
              showNavigation={true}
              showIcons={false}
              ariaLabel="Website development process"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
